import logo from '../../assets/img/logo.png';
import './style.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-brand">
          <img src={logo} alt="Logo Kemenag" className="footer-logo" />
          <div>
            <div className="footer-title">PMBM JPPT 2026</div>
            <div className="footer-subtitle">Kanwil Kementerian Agama DIY</div>
            <p className="footer-desc">
              Portal resmi Penerimaan Murid Baru Madrasah Jalur Pendaftaran Tahfidz Terpadu
              <br />
              Kantor Wilayah Kementerian Agama Daerah Istimewa Yogyakarta.
            </p>
          </div>
        </div>

        <div className="footer-info">
          <div className="footer-column">
            <h4>Kontak Kami</h4>
            <div>📍 Jl. Sukonandi No.8, Yogyakarta</div>
            <div>📞 (0274) 513613</div>
            <div>✉️ ppdb@kemenag-diy.go.id</div>
          </div>

          <div className="footer-column">
            <h4>Link Terkait</h4>
            <div><a href="#">Panduan PMBM</a></div>
            <div><a href="#">FAQ</a></div>
            <div><a href="https://diy.kemenag.go.id/news/">Kemenag DIY</a></div>
            <div><a href="https://jogjamadrasahdigital.net/web">Jogja Madrasah Digital</a></div>
          </div>
        </div>
      </div>
      <hr></hr>
      <div className="footer-bottom">
        © 2026 PMBM JPPT Kanwil Kemenag DIY. All rights reserved.
      </div>
    </footer>
  );
}